import { render, staticRenderFns } from "./BotOnePlatformAdd.vue?vue&type=template&id=ff88f87e&"
import script from "./BotOnePlatformAdd.vue?vue&type=script&lang=js&"
export * from "./BotOnePlatformAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports